import React, { useState } from 'react';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const scrollToSection = (id: string) => {
    setIsMenuOpen(false);
    // If we're not on the homepage, navigate to homepage first
    if (location.pathname !== '/') {
      // We'll use this approach to navigate and then scroll
      // This is handled in the Link component's onClick
      return;
    }
    // If we're already on the homepage, just scroll to the section
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="flex justify-between items-center h-16" data-id="element-175">
          <div className="flex items-center" data-id="element-176">
            <Link to="/" className="flex items-center" data-id="element-177">
              <Logo data-id="element-178" />
            </Link>
          </div>
          <nav className="hidden md:flex space-x-8" data-id="element-179">
            <Link to="/" className={`${isActive('/') ? 'text-pink-700' : 'text-gray-600 hover:text-pink-700'} transition-colors`} data-id="element-180">
              Home
            </Link>
            <Link to="/shop" className={`${isActive('/shop') ? 'text-pink-700' : 'text-gray-600 hover:text-pink-700'} transition-colors`} data-id="element-181">
              Shop
            </Link>
            <Link to="/how-it-works" className={`${isActive('/how-it-works') ? 'text-pink-700' : 'text-gray-600 hover:text-pink-700'} transition-colors`} data-id="element-182">
              How It Works
            </Link>
            <Link to={location.pathname === '/' ? '#plans' : '/#plans'} className="text-gray-600 hover:text-pink-700 transition-colors" onClick={e => {
            if (location.pathname === '/') {
              e.preventDefault();
              scrollToSection('plans');
            }
          }} data-id="element-183">
              Plans
            </Link>
            <Link to={location.pathname === '/' ? '#pricing' : '/#pricing'} className="text-gray-600 hover:text-pink-700 transition-colors" onClick={e => {
            if (location.pathname === '/') {
              e.preventDefault();
              scrollToSection('pricing');
            }
          }} data-id="element-184">
              Pricing
            </Link>
            <Link to="/request-flowers" className={`${isActive('/request-flowers') ? 'text-pink-700' : 'text-gray-600 hover:text-pink-700'} transition-colors`} data-id="element-185">
              Request Flowers
            </Link>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-186">
            <Link to="/login" className={`px-4 py-2 rounded-md ${isActive('/login') ? 'bg-pink-50' : ''} text-pink-700 border border-pink-700 hover:bg-pink-50 transition-colors`} data-id="element-187">
              Log In
            </Link>
            <Link to="/signup" className={`px-4 py-2 rounded-md ${isActive('/signup') ? 'bg-pink-800' : 'bg-pink-700 hover:bg-pink-800'} text-white transition-colors`} data-id="element-188">
              Sign Up
            </Link>
            <Link to="/cart" className={`p-2 rounded-full ${isActive('/cart') ? 'bg-gray-100' : 'hover:bg-gray-100'} relative`} data-id="element-189">
              <ShoppingCart className="h-5 w-5 text-gray-600" data-id="element-190" />
              <span className="absolute -top-1 -right-1 bg-pink-700 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center" data-id="element-191">
                0
              </span>
            </Link>
          </div>
          <div className="md:hidden" data-id="element-192">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100" data-id="element-193">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-194" /> : <Menu className="h-6 w-6" data-id="element-195" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-196">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-197">
            <Link to="/" className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/') ? 'text-pink-700 bg-gray-50' : 'text-gray-700 hover:text-pink-700 hover:bg-gray-50'}`} onClick={() => setIsMenuOpen(false)} data-id="element-198">
              Home
            </Link>
            <Link to="/shop" className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/shop') ? 'text-pink-700 bg-gray-50' : 'text-gray-700 hover:text-pink-700 hover:bg-gray-50'}`} onClick={() => setIsMenuOpen(false)} data-id="element-199">
              Shop
            </Link>
            <Link to="/how-it-works" className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/how-it-works') ? 'text-pink-700 bg-gray-50' : 'text-gray-700 hover:text-pink-700 hover:bg-gray-50'}`} onClick={() => setIsMenuOpen(false)} data-id="element-200">
              How It Works
            </Link>
            <Link to={location.pathname === '/' ? '#plans' : '/#plans'} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-pink-700 hover:bg-gray-50" onClick={e => {
          if (location.pathname === '/') {
            e.preventDefault();
            scrollToSection('plans');
          } else {
            setIsMenuOpen(false);
          }
        }} data-id="element-201">
              Plans
            </Link>
            <Link to={location.pathname === '/' ? '#pricing' : '/#pricing'} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-pink-700 hover:bg-gray-50" onClick={e => {
          if (location.pathname === '/') {
            e.preventDefault();
            scrollToSection('pricing');
          } else {
            setIsMenuOpen(false);
          }
        }} data-id="element-202">
              Pricing
            </Link>
            <Link to="/request-flowers" className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/request-flowers') ? 'text-pink-700 bg-gray-50' : 'text-gray-700 hover:text-pink-700 hover:bg-gray-50'}`} onClick={() => setIsMenuOpen(false)} data-id="element-203">
              Request Flowers
            </Link>
            <div className="flex space-x-2 mt-4" data-id="element-204">
              <Link to="/login" className={`flex-1 px-4 py-2 rounded-md ${isActive('/login') ? 'bg-pink-50' : ''} text-pink-700 border border-pink-700 hover:bg-pink-50 transition-colors`} onClick={() => setIsMenuOpen(false)} data-id="element-205">
                Log In
              </Link>
              <Link to="/signup" className={`flex-1 px-4 py-2 rounded-md ${isActive('/signup') ? 'bg-pink-800' : 'bg-pink-700 hover:bg-pink-800'} text-white transition-colors`} onClick={() => setIsMenuOpen(false)} data-id="element-206">
                Sign Up
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}